import * as React from "react"
import { Dispatch, SetStateAction } from "react"
interface RoleProps {
  roleSelectedOption: { title: string } | undefined
  setRoleSelectedOption: Dispatch<SetStateAction<{ title: string } | undefined>>
}
export const Role = ({
  roleSelectedOption,
  setRoleSelectedOption,
}: RoleProps) => {
  const data = [
    {
      title: "What’s your Role?",
      options: [
        {
          title: "Owner/CEO",
        },
        {
          title: "Marketing",
        },
        {
          title: "Design",
        },
        {
          title: "Business Development",
        },
        {
          title: "Operations",
        },
        {
          title: "R&D",
        },
        {
          title: "Product",
        },
        {
          title: "Sales",
        },
        {
          title: "Finance",
        },
        {
          title: "Legal",
        },
        {
          title: "HR",
        },
        {
          title: "IT",
        },
      ],
    },
  ]
  return (
    <div className="mt-10 pt-10 container mx-auto">
      <div className="flex gap-1 justify-center">
        <h2 className="text-black text-3xl font-bold text-center">
          {data[0].title}
        </h2>
        <p className="pt-2 text-black"> (Optional)</p>
      </div>
      <div className="flex gap-3 flex-wrap mx-2 lg:justify-around justify-center items-center mt-10">
        {data[0].options.map((item, index) => (
          <div
            key={index}
            onClick={() =>
              setRoleSelectedOption(
                roleSelectedOption?.title === item.title ? undefined : item
              )
            }
            className={`bg-real-time-options hover:border-[#7B68EC] cursor-pointer flex flex-col text-center items-center lg:px-16 px-2 py-3 rounded-xl justify-center ${
              roleSelectedOption?.title === item.title
                ? "border-none bg-input"
                : ""
            }`}
          >
            <p
              className={`lg:text-sm font-semibold text-xs ${
                roleSelectedOption?.title === item.title
                  ? "text-[#7B68EC]"
                  : " text-black"
              }`}
            >
              {item.title}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}
